import React, { useState, useEffect } from 'react';

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down significantly
  // Increased threshold to make button appear only after scrolling down more
  const toggleVisibility = () => {
    // Increase threshold to a much higher value (e.g., 600px)
    // This ensures the button only appears after scrolling down considerably
    if (window.pageYOffset > 600) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    // Initial check to ensure button is hidden on load
    setIsVisible(false); // Explicitly hide on initial load
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // More robust scroll to top handler
  const scrollToTop = (e) => {
    e.preventDefault();
    
    // Set a global flag to indicate we're scrolling to top
    window.isScrollingToTop = true;
    
    // Aggressively enforce home as active - triple redundancy approach
    
    // 1. Direct DOM manipulation for immediate visual feedback
    const allLinks = document.querySelectorAll('.navbar-nav .nav-link');
    allLinks.forEach(link => {
      link.classList.remove('active');
      link.blur(); // Remove focus states
      link.style.color = ''; // Reset any inline styles
    });
    
    // Special aggressive handling for the We! menu
    const picturesLink = document.querySelector('.nav-link-pictures');
    if (picturesLink) {
      picturesLink.classList.remove('active');
      picturesLink.style.color = '';
    }
    
    const homeLink = document.querySelector('.nav-link-home');
    if (homeLink) {
      homeLink.classList.add('active');
    }
    
    // 2. Global state update function if available
    if (typeof window.globalSetActiveLink === 'function') {
      window.globalSetActiveLink('home');
    }
    
    // 3. Custom event as fallback/redundancy
    window.dispatchEvent(new CustomEvent('setActiveLink', { 
      detail: 'home',
      bubbles: true 
    }));
    
    // Scroll to top
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    
    // Make one final check after scroll animation completes
    setTimeout(() => {
      // Re-apply active state to home in case something changed it
      allLinks.forEach(link => {
        link.classList.remove('active');
        link.blur(); // Remove focus
      });
      
      // Special aggressive handling for the We! menu again after timeout
      if (picturesLink) {
        picturesLink.classList.remove('active');
      }
      
      if (homeLink) {
        homeLink.classList.add('active');
      }
      
      // Force a scroll event to ensure handlers run
      window.dispatchEvent(new Event('scroll'));
      
      // Reset the flag after scrolling is complete
      window.isScrollingToTop = false;
    }, 1500); // Longer timeout for mobile devices
  };

  return (
    <a 
      href="#top"
      className="scroll-to-top" 
      id="scrollToTop" 
      style={{ 
        display: isVisible ? 'block' : 'none',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out'
      }}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      ↑
    </a>
  );
}

export default ScrollToTop;
